import { z } from 'zod';
import {} from "./companies.dto.js";
export const FindCompanyBySlugRequestDTOSchema = z.object({
    params: z.object({
        slug: z.string().min(1),
    }),
});
//# sourceMappingURL=find-company-by-slug.dto.js.map